/* eslint-disable */
import React from 'react';

import './styles.css';

import Radio from '@mui/material/Radio';
import {
  FormControlLabel,
  FormControlLabelProps,
  RadioProps,
} from '@mui/material';

interface Props {
  controllerProps?: RadioProps;
}

type RadioButtonType = Props & Partial<FormControlLabelProps>;

export function RadioButton({
  controllerProps,
  label = '',
  ...props
}: RadioButtonType) {
  return (
    <FormControlLabel
      classes={{ label: 'radio-btn-label' }}
      value={props?.value}
      control={<Radio {...controllerProps} />}
      label={label}
      {...props}
    />
  );
}
